export default __webpack_public_path__ + "static/media/footer_logo_pp@2x.7557b1a5.png";